import { useTranslations } from 'next-intl';

import { FormattedMessage } from '@flipster/i18n';
import { TextButton } from '@flipster/react/design-system/text-button';
import { css } from '@flipster/styled-system/css';
import { flex } from '@flipster/styled-system/patterns';
import { ProdStaticPath } from '@flipster/utils/url';

import { getFlipsterUrl } from '../../shared/urls';

const CrossMarginVersusIsolatedMargin = () => {
  const t = useTranslations();
  return (
    <div className={flex({ flex: 1, direction: 'column', gap: 16 })}>
      <h2 className={css({ textStyle: 'Title/M', color: 'content.default.level-5' })}>
        <FormattedMessage id='Autogen_common.r251126.s_Cross_margin_vs_Isolated_margin' />
      </h2>
      <div
        className={flex({
          justify: 'center',
          align: 'center',
          bg: 'background.default.level-1',
          rounded: 8,
        })}
      >
        <img
          src={`${ProdStaticPath}/images/web/collateral_overview_01.png`}
          alt='cross-margin-versus-isolated-margin'
          width={328}
          height={190}
        />
      </div>
      <div className={flex({ direction: 'column', gap: 8 })}>
        <p className={css({ textStyle: 'Text/M/Regular', color: 'content.default.level-3' })}>
          <FormattedMessage id='Autogen_common.r251126.s_Cross_margin_uses_one_account_balance_as_collateral_for_all_positions_reducing_liquidation_risk_Isolated_margin_separates_each_position_limiting_risk_to_that_position' />
        </p>
        <div>
          <TextButton
            as='a'
            href={`${getFlipsterUrl()}/support/guide/margin-trading`}
            css={{ mt: 16 }}
            color='accent'
            size='medium'
            label={t('Autogen_common.r251126.s_Learn_more_about_cross_margin')}
          />
        </div>
      </div>
    </div>
  );
};

export default CrossMarginVersusIsolatedMargin;
